import api from "@/services/api.service";
import { ActionTree } from "vuex";
import { SessionsState, UpdateSessionParams } from "./types";
import { RootState } from "../types";

export const actions: ActionTree<SessionsState, RootState> = {
	async updateSession({ commit, rootGetters, rootState }, { resourceId, eventId, regionId }: UpdateSessionParams) {
		// For backwards compatability reasons, we default the regionUrl to use for sessions to the one specified by the
		// current event region (usually the local one, unless the user is handling a remote event).
		let regionUrl = rootState.siteMonitor.eventRegion.regionUrl;

		// ...but, if a region ID has been provided, override the URL with the correct one.
		if (regionId) {
			regionUrl = rootGetters["regions/getRegionUrl"](regionId);
		}

		if (resourceId === undefined) {
			console.log("Undefined resourceId");
			return 404;
		}

		var sessionResponse = await api.sessionGet(resourceId, eventId, regionUrl);
		if (sessionResponse.status == 200) {
			commit("setResourceSessionId", {
				resourceId,
				sessionId: sessionResponse.data.authSessionID,
				regionId
			});
		}

		commit("setResourceStatus", sessionResponse.status);
		return sessionResponse.status;
	},
	clearSessions({ commit }) {
		commit("clearResourceSessionId", 2);
		commit("clearResourceSessionId", 3);
	}
};
